import $ from 'jquery'

export class Calculator {

  constructor($container) {
    this.$container = $container
    this.$inputNotDisabled = this.$container.find('input:not(:disabled)')
    this.$selects = this.$container.find('select')
    this.lastInputChangeIsBaseImponible = true

    this.$inputBaseImponible = this.$container.find('[name="base_imponible"]')
    this.$inputTipoDelIva = this.$container.find('[name="tipo_del_iva"]')
    this.$inputImporteDelIva = this.$container.find('[name="importe_del_iva"]')
    this.$inputPrecioConIva = this.$container.find('[name="precio_con_iva"]')
    this.$inputRetencionDeIrpf = this.$container.find('[name="retencion_de_irpf"]')
    this.$inputResultado = this.$container.find('[name="resultado"]')
    this.$inputImporteTotalDeLaFactura = this.$container.find('[name="importe_total_de_la_factura"]')

    this.$inputNotDisabled.on('focusout', this.handleFocusOutInput.bind(this))
    this.$inputNotDisabled.on('focusin', this.handleFocusInInput.bind(this))
    this.$inputNotDisabled.on('input', this.handleInputInput.bind(this))
    this.$selects.on('change', this.handleChangeSelects.bind(this))
  }

  handleInputInput(e) {
    let $input = $(e.currentTarget)

    if ($input.attr('id') === this.$inputBaseImponible.attr('id')) {
      this.calculatePrice()
      this.lastInputChangeIsBaseImponible = true
    } else {
      this.calculatePriceReverse()
      this.lastInputChangeIsBaseImponible = false
    }
  }

  handleFocusOutInput(e) {
    let $input = $(e.currentTarget)
    let val = $input.val()
    let formatted = this.formatePrice(val)

    $input.val(formatted)
  }

  handleFocusInInput(e) {
    let $input = $(e.currentTarget)
    let val = $input.val()
    let formatted = this.formateValue(val)

    $input.val(formatted)
  }

  handleChangeSelects() {
    if (this.lastInputChangeIsBaseImponible) {
      this.calculatePrice()
    } else {
      this.calculatePriceReverse()
    }
  }

  calculatePrice() {
    let basePrice = this.$inputBaseImponible.val()
    let ivaRate = this.getValTipoDelIva()
    let irpfRate = this.getRetencionDeIrpf()

    basePrice = this.formateValue(basePrice)
    ivaRate = basePrice * ivaRate / 100
    irpfRate = basePrice * irpfRate / 100

    let priceWithIva = ivaRate + basePrice
    let finalPrice = basePrice + ivaRate - irpfRate

    this.$inputPrecioConIva.val(this.formatePrice(priceWithIva.toString()))
    this.$inputImporteDelIva.val(this.formatePrice(ivaRate.toString()))
    this.$inputResultado.val(this.formatePrice(irpfRate.toString()))
    this.$inputImporteTotalDeLaFactura.val(this.formatePrice(finalPrice))
  }

  calculatePriceReverse() {
    let finalPrice = this.$inputImporteTotalDeLaFactura.val()

    finalPrice = this.formateValue(finalPrice)

    let ivaRate = this.getValTipoDelIva()
    let irpfRate = this.getRetencionDeIrpf()
    let factor = 1 + ivaRate / 100 - irpfRate / 100
    let basePrice = finalPrice / factor
    let iva = basePrice * ivaRate / 100
    let irpf = basePrice * irpfRate / 100
    let priceWithIva = basePrice + iva

    this.$inputBaseImponible.val(this.formatePrice(basePrice.toString()))
    this.$inputImporteDelIva.val(this.formatePrice(iva.toString()))
    this.$inputResultado.val(this.formatePrice(irpf.toString()))
    this.$inputPrecioConIva.val(this.formatePrice(priceWithIva.toString()))
  }

  getValTipoDelIva() {
    return parseFloat(this.$inputTipoDelIva.val())
  }

  getRetencionDeIrpf() {
    return parseFloat(this.$inputRetencionDeIrpf.val())
  }

  formateValue(val) {
    val = val.replace('€', '').trim()
    val = val.replace(',', '.')

    let num = parseFloat(val)

    if (isNaN(num)) {
      return 0
    }

    return num
  }

  formatePrice(val) {
    val = val.toString()
    val = val.replace('.', ',')
    val = val.replace(/[^0-9,]/g, '')

    let parts = val.split(',')
    let intPart = parts[0] || '0'
    let decPart = parts[1] || ''

    decPart = decPart.substring(0, 2)
    intPart = intPart.replace(/^0+(?!$)/, '')

    let formatted = intPart

    if (val.includes(',')) {
      formatted += ',' + decPart.padEnd(2, '0')
    } else {
      formatted += ',00'
    }

    if (formatted === '') {
      formatted = '0'
    }

    formatted += ' €'

    return formatted
  }
}
